import HomePage from "./components/pages/HomePage";
import NotFoundPage from "./components/pages/NotFoundPage";
import PanelLeftPage from "./components/pages/PanelLeftPage";
// INIT-GENERATOR.PHP importConfig
// END-GENERATOR.PHP importConfig

export default [
  {
    path: "/",
    component: HomePage,
  },
  {
    path: "/panel-left/",
    component: PanelLeftPage,
  },
  // INIT-GENERATOR.PHP jsonConfig
  // END-GENERATOR.PHP jsonConfig
  {
    path: "(.*)",
    component: NotFoundPage,
  },
];



// WEBPACK FOOTER //
// ./src/routes.ts